// extracted by mini-css-extract-plugin
export default {"container":"LfZXFiwCCjXREwUgv5_m","title":"eSkFkusNUeryinenjM9L"};